import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import InfoSections from "./components/InfoSections";
import PillarArticles from "./components/PillarArticles";
import Faq from "./components/Faq";
import FinalCta from "./components/FinalCta";
import JsonLd, { SITE_URL, FAVICON_URL } from "@/components/feature/JsonLd";

export default function Home() {
  return (
    <div>
      <JsonLd
        data={{
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: "USFansLink — USFans Spreadsheet Resource Hub",
          url: `${SITE_URL}/en/`,
          inLanguage: "en",
          description:
            "USFans Spreadsheet resource hub — product guides, seller information, shipping research, reviews and safety tips in one multilingual place.",
          publisher: {
            "@type": "Organization",
            name: "USFansLink",
            logo: { "@type": "ImageObject", url: FAVICON_URL },
          },
        }}
      />
      <JsonLd
        data={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "USFansLink",
          url: `${SITE_URL}/en/`,
          logo: { "@type": "ImageObject", url: FAVICON_URL },
        }}
      />
      <Hero />
      <CategoryGrid />
      <InfoSections />
      <PillarArticles />
      <Faq />
      <FinalCta />
    </div>
  );
}